import CreateForumPost from './CreateForumPost'
export default CreateForumPost;